module.exports = __webpack_public_path__ + "img/flower_leaf_7.ce6e885c.png";